import { AxiosResponse } from 'axios'
import apiClient from './common/common'
import { PurchaseRequest } from './common/requests'
import { PurchaseCredixResponse, PurchasePanaceaPayResponse } from './common/responses'
import { Status } from './common/statuses'

/**
 * パナシアペイ購入API
 * @param request
 * @param callback
 */
export const purchasePanaceaPayAPI = async (request: PurchaseRequest, callback: (status: Status, response: PurchasePanaceaPayResponse) => void) => {
  await apiClient.post('/purchase/panaceaPay', request).then((response: AxiosResponse<PurchasePanaceaPayResponse>) => {
    const status = response?.headers['x-aqc-status'] ?? 'failed'
    const apiResult = response?.data ?? {}
    callback(status, apiResult)
  })
}

/**
 * CREDIX購入API
 * @param request
 * @param callback
 */
export const purchaseCredixAPI = async (request: PurchaseRequest, callback: (status: Status, response: PurchaseCredixResponse) => void) => {
  await apiClient.post('/purchase/credix', request).then((response: AxiosResponse<PurchaseCredixResponse>) => {
    const status = response?.headers['x-aqc-status'] ?? 'failed'
    const apiResult = response?.data ?? {}
    callback(status, apiResult)
  })
}
